export default "/map-background.c1e1cece-3cfa7b.jpg";